import { locales, languages } from './locales';

export const translations = locales;
export { languages };
export type Language = 'fr' | 'en';
export type TranslationKeys = typeof locales.fr;
